import { useBreadcrumbs } from 'global/cnr/contexts/useHelpers/useBreadcrumbs'
import { appDataSidebarHandlers, appDataSidebarInitialState, appDataSidebarReducer } from 'global/cnr/reducers/AppDataSidebarReducer'
import { createInitials } from 'global/common/dataAdjust'
import { PopupSelect } from 'global/components/popups/PopupSelect'
import MiniSwipe from 'global/components/swipers/MiniSwipe'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import _ from 'lodash'
import { useContext, useEffect, useMemo, useReducer, useState } from 'react'
import { Dropdown, Icon } from 'semantic-ui-react'
import { FrameworkContext } from '../../cnr/contexts/FrameworkContent'
import { ParentContext } from '../../cnr/contexts/ParentContext'
import { frameworkLeftTypes } from '../../cnr/reducers/FrameworkReducer'
import { convertHelpers } from '../../common/convert'
import UiSaveButtons from '../../components/buttons/UiSaveButtons'
import DropdownOptionsMenu from '../../components/forms/elements/DropdownOptionsMenu'
import AlphabetMenuWithProvider from '../../components/menus/AlphabetMenu'
import SearchInput from '../../components/menus/SearchInput'
import TreeViewer from '../../components/viewers/TreeViewer'
import { appIconTypes } from '../../enums/appIconTypes'
import { gEnums } from '../../enums/globalEnums'
import { settingsIconTypes } from '../../enums/settingsIconTypes'
import { createRefPath_client } from '../../firestoreData/appData/appRefPaths'
import { recreateDataHelpers } from '../../firestoreData/appData/fsRecreateData'
import { updateLinkHelpers } from '../../firestoreData/updates/subUpdates/fsUpdate_dataLInks'
import ConfirmationWrapper from '../../wrappers/ConfirmationWrapper'
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper'
import { openExternal } from '../helpers/settingsLinks'
import ItemModifySidebar from './ItemModifySidebar'
import { useDuplicates } from 'global/cnr/contexts/useHelpers/useDuplicates'
import { useAppData } from 'global/cnr/contexts/useHelpers/useAppData'

const _appDataOptionTypes = {
  backupAllData: 'backupAllData',
  backupAllDocuments: 'backupAllDocuments',
  backupData: 'backupData',
  createAppDataDocuments: 'createAppDataDocuments',
  createAppLinks: 'createAppLinks',
  createClientProfiles: 'createClientProfiles',
  createClientProfileUrls: 'createClientProfileUrls',
  createDocuments: 'createDocuments',
  exportAllToGoogleSheets: 'exportAllToGoogleSheets',
  exportToGoogleSheets: 'exportToGoogleSheets',
  fixDataLinks: 'fixDataLinks',
  mergeDuplicates: 'mergeDuplicates',
  mergeToCollection: 'mergeToCollection',
  removeBadData: 'removeBadData',
  restoreFromBackupData: 'restoreFromBackupData',
  viewDocumentData: 'viewDocumentData',
}

const AppDataSidebar = (props) => {

  const { fromLongPress } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, handlers, navigate, fns, fn_cls } = parentContext ?? {}
  const { appUser_state, eventInfo_state, paps_state, currentSettings_state } = states
  const { appUser } = appUser_state ?? {}
  const { appUsers_handlers } = handlers
  const { database_fns } = fns
  const { pathViews, rootPaths } = paps_state ?? {}
  const { appDataDocuments, staticViews, eventData } = eventInfo_state ?? {}
  const { aps_global, aps_viewItems, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { storageOptions, googleSheets } = aps_global ?? {}
  const { clientStorageImageCollections } = storageOptions ?? {}
  const { googleSheetsId } = googleSheets ?? {}
  const { appUserCollection } = aps_appUserSettings ?? {}
  const { name: eventName } = eventData ?? {}

  const _appDataDocuments = appDataDocuments ? appDataDocuments : staticViews

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { frInfo } = framework_state ?? {}
  const { view: framewordRightView } = frInfo ?? {}

  const [appDataSidebar_state, dispatch] = useReducer(appDataSidebarReducer, appDataSidebarInitialState({ currentResults: _appDataDocuments, aps_viewItems: aps_viewItems }));
  const appDataSidebar_handlers = appDataSidebarHandlers(dispatch);

  const {
    allGroups,
    appDataKeys,
    appLinkData,
    backupData,
    clientProfiles,
    currentConfirmationType,
    currentDataLinks,
    currentResults,
    selectedAppData,
    selectedAppDataKey,
    selectedCollection,
    selectedInfo,
    updating,
    useAlpha,
  } = appDataSidebar_state

  const currentGroup = allGroups?.[allGroups.length - 1] || null
  const currentIndex = allGroups.length - 1

  const [currentAlpha, setCurrentAlpha] = useState('A')
  const { duplicates, updateDuplicates } = useDuplicates({ appDataDocuments, appUserCollection })

  const {
    backupAllDocuments,
    backupDocument,
    backupDocuments,
    exportAllToGoogleSheets,
    exportToGoogleSheets,
    getBackup,
    removeBadData,
    restoreFromBackup,
    updateDocuments,
    updateMultipleDocuments,
    updating: _updating,
  } = useAppData()

  const mergeLinks = (appDataLinks, documentLinks) => {

    const mergedLinks = _.cloneDeep(appDataLinks); // Start with a copy of appDataLinks

    _.forEach(documentLinks, (value, key) => {
      if (!_.has(appDataLinks, key)) {
        // Add missing entries from documentLinks
        mergedLinks[key] = value;
      } else if (_.isObject(value) && !_.isArray(value)) {
        // Recursively merge nested objects
        mergedLinks[key] = mergeLinks(appDataLinks[key], value);
      }
    });

    return mergedLinks;

  };

  const mergeLinksWithPrefix = (appDataLinks, documentLinks) => {
    const mergedLinks = _.cloneDeep(appDataLinks); // Start with a copy of appDataLinks

    _.forEach(documentLinks, (value, key) => {
      if (!_.has(appDataLinks, key)) {
        // Add missing entries with an '_' prefix in the key
        mergedLinks[`_${key}`] = value;
      } else if (_.isObject(value) && !_.isArray(value)) {
        // Recursively merge nested objects
        mergedLinks[key] = mergeLinksWithPrefix(appDataLinks[key], value);
      }
    });

    return mergedLinks;
  };

  useEffect(() => {
    const _appDataKeys = _appDataDocuments ? _.keys(_appDataDocuments) : []
    appDataSidebar_handlers.handleSet_appDataKeys(_.sortBy(_appDataKeys))
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    switch (currentConfirmationType) {
      case _appDataOptionTypes.createClientProfiles:
        const _appProfiles = {}
        _.forEach(selectedAppData, (appData) => {
          const { email, firstName, lastName, _itemKey } = appData
          if (email) {
            const appProfile = {
              email: email,
              firstName,
              lastName,
              displayName: firstName + ' ' + lastName,
              initials: createInitials(firstName + ' ' + lastName),
              events: {
                [pathViews.events]: {
                  name: eventName,
                  appUserKey: _itemKey
                }
              }
            }
            _appProfiles[email] = appProfile
          }
        })
        const _appProfilesS = _.orderBy(_appProfiles, ['lastName', 'firstName'])
        appDataSidebar_handlers.handleSet_clientProfiles(_appProfilesS)
        break;
      case _appDataOptionTypes.restoreFromBackupData:
        handleGetBackup()
        break;
      // case _appDataOptionTypes.createDocuments:
      //   handleGetDocuments()
      //   break;
      case _appDataOptionTypes.fixDataLinks:
        handleGetDataLinks()
        break;
      case _appDataOptionTypes.createAppLinks:
        const cb = (documentLinks) => {
          const getDifferences = (obj1, obj2) => {
            const changes = {};

            _.forEach(obj1, (value, key) => {
              if (!_.has(obj2, key)) {
                changes[key] = { oldValue: value, newValue: undefined };
              } else if (_.isObject(value) && !_.isArray(value)) {
                const nestedChanges = getDifferences(value, obj2[key]);
                if (!_.isEmpty(nestedChanges)) {
                  changes[key] = nestedChanges;
                }
              } else if (!_.isEqual(value, obj2[key])) {
                changes[key] = { oldValue: value, newValue: obj2[key] };
              }
            });

            _.forEach(obj2, (value, key) => {
              if (!_.has(obj1, key)) {
                changes[key] = { oldValue: undefined, newValue: value };
              }
            });

            return changes;
          };



          appDataSidebar_handlers.handleSet_appLinkData(documentLinks)
        }
        updateLinkHelpers.createAppLinks(pathViews, _appDataDocuments, cb)
      // eventInfo_handlers.handleCreate_appDataLinks(false, cb)
      default:
      // nothing
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentConfirmationType]);

  const handle_showConfirmation = (opts) => {
    const { optionType } = opts
    appDataSidebar_handlers.handleSet_currentConfirmationType(currentConfirmationType === optionType ? null : optionType)
  }

  const handle_viewData = () => {
    console.log(appDataDocuments)
  }

  const handleOpenDb = () => {
    if (selectedInfo) {
      const { appDataItemKey } = selectedInfo
      openExternal.db(pathViews, null, [appDataItemKey])
    }
  }

  const handleShow_appDashboard = (e, opts) => {
    e.stopPropagation()
    const { frt, collectionKey } = opts ?? {}
    framework_handlers.handleShow_frameworkLeft()
    framework_handlers.handleShow_appDashboard(frt, collectionKey)
  }

  const handleGotoItem = (e, key, itemKey) => {
    e && e.stopPropagation()
    let _path = rootPaths.events + key;
    if (itemKey) { _path += '/' + itemKey }
    navigate(_path)
  }

  const handleAlphaChange = (alphaItem) => {
    const _alphaChar = String.fromCharCode(alphaItem)
    setCurrentAlpha(_alphaChar)
  }

  const _grouping = {
    alphaDisplayType: gEnums.alphaDisplayTypes.vertical,
    useVerticalHidden: true,
    verticalOpacity: gEnums.opacityTypes.light,
    restrictToExisting: true,
    showAlphaCount: true,
    origin: 'ads',
  }

  const alphabetMenu = (dataItems) => <AlphabetMenuWithProvider
    origin={'appDataSidebar'}
    dataItems={dataItems}
    handleAlphaChange={handleAlphaChange}
    grouping={_grouping}
  />

  const backLinks = useMemo(() => {
    if (!allGroups) return;
    const bl = _.map(
      allGroups?.slice(0, -1),
      (group) => (
        {
          key: group.key || 0,
          caption: _.startCase(group.key),
          item: group.item || null
        }
      )
    );
    return bl
  }, [allGroups])

  const bcrb = useBreadcrumbs({ items: backLinks, onClick: appDataSidebar_handlers.handleGo_back })

  const header_top = () => {
    const { key, text } = currentGroup
    const _caption = text || _.startCase(key)
    return <div className='swr-header'>
      {bcrb}
      <div className='swr-header-cap'><Icon color={'blue'} name='arrow left' onClick={() => appDataSidebar_handlers.handleGo_back()}></Icon>{_caption}</div>
    </div>
  }

  const fnAltContent = (item) => {

    let selections = [];

    switch (currentGroup?.key) {
      case 'appData':
        selections = {
          openPage: { key: 'openPage', icon: 'file alternate outline', iconColor: 'blue' },
          // bulkImageUpload: { icon: 'images ', iconColor: 'blue' },
        }
        break;
      default:
        selections = {
          openPageItem: { icon: 'file alternate outline', iconColor: 'blue' },
        }
    }

    convertHelpers.createItemKeys(selections)

    if (_.isEmpty(selections)) { return; }

    const cb = (selectedItem) => {
      switch (selectedItem._itemKey) {
        case selections.bulkImageUpload?._itemKey:
          handleShow_appDashboard(null, { frt: frameworkLeftTypes.bulkImageUpload, collectionKey: item.key })
          break;
        case selections.openPage?._itemKey:
          handleGotoItem(null, item.key)
          break;
        case selections.openPageItem?._itemKey:
          handleGotoItem(null, currentGroup.key, item.key)
          break;
      }
    }

    return <PopupSelect items={selections} dataItem={item} handleMenuAction={cb} icon={'ellipsis vertical'} />
  }

  const filterByAlpha = (items, selectedAlpha) => {
    if (!selectedAlpha) return items;
    const alpha = _.toUpper(selectedAlpha);
    return _.filter(items, (item) => {
      const value = item.lastName || item.name || '';
      return _.startsWith(_.toUpper(value), alpha);
    });
  };

  const itemSquares_allData = () => {
    if (appDataKeys) {
      const hc = (item) => {
        // handleSelect_appData(item.key)
        appDataSidebar_handlers.handleSelect_appData(item)
      }

      const _itemz = _.map(appDataKeys, (value) => {
        return {
          text: _.startCase(value),
          key: value,
          count: currentResults && currentResults[value] ? Object.keys(currentResults[value]).length : 0
        }
      })

      const ims_pages = <ItemMenuSquares
        fn_altContent={fnAltContent}
        imsType={_imsTypes.inline}
        menuItems={_itemz}
        onClick={hc}
      />

      return ims_pages

    }
  }

  const handleAddDataItem = () => {
    const _selectedInfo = { ...selectedInfo }
    _selectedInfo.appDataItem = {}
    _selectedInfo.appDataItemItem = 'new'
    appDataSidebar_handlers.handleSelect_appDataItemNew(_selectedInfo)
  }

  const itemSquares_pageData = () => {

    const hc = (item) => appDataSidebar_handlers.handleSelect_appDataItem(item)

    if (selectedAppData) {
      let cn = 'menu-ids ads'

      if (useAlpha) { cn += ' alpha' }

      const _itemz = []
      let currentLetter = null;

      let _selectedAppData = selectedAppData

      if (useAlpha && currentAlpha) {
        _selectedAppData = filterByAlpha(selectedAppData, currentAlpha)
      }

      _.forEach(_selectedAppData, (appData) => {
        const { _itemKey, name, lastName, firstName, startDate, startTime } = appData

        const displayName = lastName ? `${lastName}, ${firstName}` : name
        const alpha = displayName?.[0]?.toUpperCase()

        // 🔹 insert header when letter changes
        if (useAlpha && alpha && alpha !== currentLetter) {
          _itemz.push({
            isHeader: true,
            text: alpha,
            key: `header-${alpha}`
          })
          currentLetter = alpha
        }

        const hasSubtext = startDate

        _itemz.push({
          text: lastName ? `${lastName}, ${firstName}` : name,
          subText: hasSubtext ? `${startDate} - ${startTime}` : null,
          key: _itemKey,
          _itemKey: _itemKey,
        })
      })

      const ims_page = <ItemMenuSquares
        fn_altContent={fnAltContent}
        imsType={_imsTypes.inline}
        menuItems={_itemz}
        onClick={hc}
        noItemIcon={true}
      />

      const _content = useAlpha ? <div>
        {useAlpha && alphabetMenu(selectedAppData)}
        {ims_page}
      </div> : ims_page

      const ddd = <Wrapper
        content={_.isEmpty(selectedAppData) ? <div>No Data</div> : _content}
        wrapperType={wrapperTypes.paddedHeader}
        css={{ content: useAlpha && ' alpha' }}
      />

      return ddd

    }
  }


  const header_main = () => <div className='header-flex-right'>
    <div><Icon name='arrow left' color={'blue'} onClick={() => { framework_handlers.handleShow_frameworkLeft() }} /></div>
    <div>{'App Data'}</div>
  </div >

  const handleSearchResults = (r) => {
    const { results } = r
    // appDataSidebar_handlers.handleSet_appDataKeys(_.sortBy(_appDataKeys))
    // appDataSidebar_handlers.handleSet_currentResults(results)
  }

  const searchInput = () => <SearchInput searchType={'appDataDocuments'} data={_appDataDocuments} handleResults={handleSearchResults} />

  // THIS WILL COMMIT THE DATA
  const handleCommit = async () => {

    appDataSidebar_handlers.handleSet_updating(true)

    const cb_commit = () => {
      appDataSidebar_handlers.handleSet_updating(false)
    }

    switch (currentConfirmationType) {
      case _appDataOptionTypes.fixDataLinks:
        const opts = { deletePrior: false, merge: true, allowUpdates: true }
        recreateDataHelpers.updateCollectionsData(pathViews, currentDataLinks, opts)
        // await handleCreateAllDocuments()
        break;
      case _appDataOptionTypes.createAppDataDocuments:
        const _keys = _.keys(aps_viewItems)
        await updateMultipleDocuments(_keys, cb_commit)
        break;
      case _appDataOptionTypes.createDocuments:
        const { appDataItemKey } = selectedInfo
        await updateDocuments(appDataItemKey, null, cb_commit)
        //   await handleCreateDocuments()
        break;
      case _appDataOptionTypes.exportAllToGoogleSheets:
        await exportAllToGoogleSheets(cb_commit)
        break;
      case _appDataOptionTypes.exportToGoogleSheets:
        await exportToGoogleSheets(appDataDocuments, selectedInfo.appDataItemKey, cb_commit)
        break;
      case _appDataOptionTypes.restoreFromBackupData:
        await restoreFromBackup(selectedInfo, backupData, appDataSidebar_handlers.handleSet_currentConfirmationType)
        // await handleRestoreFromBackupData()
        break;
      case _appDataOptionTypes.mergeToCollection:
        await removeBadData(selectedInfo, cb_commit)
        // await handleRemoveBadData()
        break;
      case _appDataOptionTypes.removeBadData:
        await removeBadData(selectedInfo, cb_commit)
        // await handleRemoveBadData()
        appDataSidebar_handlers.handleSet_updating(false)
        break;
      case _appDataOptionTypes.createClientProfiles:
        await handleUpdateClientProfiles()
        break;

      case _appDataOptionTypes.createClientProfileUrls:
        await handleCreateClientProfileUrls()
        break;
      case _appDataOptionTypes.backupAllData:
        await backupDocuments(cb_commit)
        // await handleBackups()
        break;
      case _appDataOptionTypes.backupAllDocuments:
        await backupAllDocuments(cb_commit)
        // await handleBackupAllDocuments()
        break;
      case _appDataOptionTypes.backupData:
        await backupDocument(cb_commit)
        // await handleBackup()
        break;
      case _appDataOptionTypes.mergeDuplicates:
        await handleDuplicates()
        break;
      // case _appDataOptionTypes.createAppLinks:
      //   await eventInfo_handlers.handleCreate_appDataLinks(true)
      //   appDataSidebar_handlers.handleSet_updating(false)
      case _appDataOptionTypes.viewDocumentData:
        handle_viewData()
        break;
      default:
      // nothing 
    }
  }

  const handleGetDataLinks = () => {
    const dlks = updateLinkHelpers.enforceBidirectionalLinks(_appDataDocuments)
    appDataSidebar_handlers.handleSet_currentDataLinks(dlks)
  }

  const handleCreateClientProfileUrls = async () => {
    if (clientStorageImageCollections && clientStorageImageCollections.includes(selectedAppDataKey)) {
      const cb = () => {
        appDataSidebar_handlers.handleSet_updating(false)
        appDataSidebar_handlers.handleSet_currentConfirmationType()
      }
      appUsers_handlers.handleCreate_clientProfileUrls(aps_global, appUserCollection, appDataDocuments, cb)
    }
  }

  const handleUpdateClientProfiles = async () => {

    appDataSidebar_handlers.handleSet_updating(true);

    try {
      // 1. Delete all existing profiles
      const refPath1 = createRefPath_client(pathViews, ["profiles"]);
      const existingProfiles = await database_fns.get_data({ refPath: refPath1 })

      // const existingProfiles = {
      //   aaaa: {
      //     email: 'aaaa'
      //   }
      // }

      const deletePromises = _.map(existingProfiles, (existingProfile) => {
        const { email } = existingProfile;
        const refPath = createRefPath_client(pathViews, ["profiles", email]);
        return database_fns.doc_delete(refPath, null, true);
      });

      await Promise.all(deletePromises);
      console.log("Cleared profiles collection");

      // 2. Re-add updated profiles
      const addPromises = _.map(clientProfiles, (clientProfile) => {
        const { email } = clientProfile;
        const refPath = createRefPath_client(pathViews, ["profiles", email]);
        return database_fns.doc_set(refPath, clientProfile);
      });

      await Promise.all(addPromises);

      console.log("Client Profiles completed successfully!");
      appDataSidebar_handlers.handleSet_currentConfirmationType();
      appDataSidebar_handlers.handleSet_updating(false);
    } catch (error) {
      console.error("Error during Profile Update", error);
      appDataSidebar_handlers.handleSet_currentConfirmationType();
      appDataSidebar_handlers.handleSet_updating(false);
    } finally {
      appDataSidebar_handlers.handleSet_updating(false);
    }
  };

  const handleDuplicates = async () => {
    if (duplicates) {
      updateDuplicates(duplicates)
    }
    appDataSidebar_handlers.handleSet_updating(false)
  }

  const handleGetBackup = () => {
    const cb = (results) => {
      appDataSidebar_handlers.handleSet_backupData(results)
    }
    getBackup(selectedInfo, cb)
  }

  const handleKeyChange = (a, b) => appDataSidebar_handlers.handleSet_selectedCollection(b?.value)

  const options = () => {
    const opts = []
    _.forEach(appDataKeys, (adk) => {
      opts.push({ text: _.startCase(adk), value: adk, key: adk })
    })
    return opts
  }

  const dropdown = () => <Dropdown
    placeholder="Select Collection"
    selection
    options={options()}
    value={selectedCollection}
    fluid
    onChange={(e, { value }) => handleKeyChange(value)}
  />

  const ddOptions_full = () => {
    const oc = handle_showConfirmation
    const btns = []
    const btnOpt = (optionType) => {
      return { caption: _.startCase(optionType), oc, icon: appIconTypes.arrowRight, fl: true, opts: { optionType } }
    }
    btns.push({ oc: handleOpenDb, caption: 'Open Database', icon: settingsIconTypes.openDatabase, fl: true, color: 'orange' })
    btns.push(btnOpt(_appDataOptionTypes.backupAllData))
    btns.push(btnOpt(_appDataOptionTypes.backupAllDocuments))
    btns.push(btnOpt(_appDataOptionTypes.createAppDataDocuments))
    btns.push(btnOpt(_appDataOptionTypes.createAppLinks))
    btns.push(btnOpt(_appDataOptionTypes.exportAllToGoogleSheets))
    btns.push(btnOpt(_appDataOptionTypes.fixDataLinks))
    !_.isEmpty(duplicates) && btns.push(btnOpt(_appDataOptionTypes.mergeDuplicates))
    btns.push(btnOpt(_appDataOptionTypes.viewDocumentData))
    return <DropdownOptionsMenu
      menuButtons={btns}
      caption={'Actions'}
      color={'blue'}
      icon={'content'}
      float={'left'}
    />
  }

  const ddOptions_dataItem = () => {
    const btns = []
    btns.push({ oc: handleOpenDb, caption: 'Open Database', icon: settingsIconTypes.openDatabase, fl: true, color: 'orange' })
    _.forEach(_appDataOptionTypes, (optionType) => {
      switch (optionType) {
        // exclude these from the main dropdown
        case _appDataOptionTypes.backupAllData:
        case _appDataOptionTypes.backupAllDocuments:
        case _appDataOptionTypes.createAppDataDocuments:
        case _appDataOptionTypes.exportAllToGoogleSheets:
        case _appDataOptionTypes.viewDocumentData:
          break;
        case _appDataOptionTypes.createClientProfiles:
        case _appDataOptionTypes.createClientProfileUrls:
          if (appUserCollection === selectedAppDataKey) {
            btns.push({ caption: _.startCase(optionType), oc: handle_showConfirmation, icon: appIconTypes.arrowRight, fl: true, opts: { optionType: optionType } })
          }
          break;
        default:
          btns.push({ caption: _.startCase(optionType), oc: handle_showConfirmation, icon: appIconTypes.arrowRight, fl: true, opts: { optionType: optionType } })
      }
    })
    return <DropdownOptionsMenu
      menuButtons={btns}
      caption={'Actions'}
      color={'blue'}
      icon={'content'}
      float={'left'}
    />
  }

  const footer_content = () => {
    const btns = []
    return <UiSaveButtons others={btns} dropdowns={ddOptions_full()} />
  }

  const footer_appDataItem = () => {
    const btns = []
    btns.push({ oc: handleAddDataItem, caption: 'Add', icon: settingsIconTypes.add, color: 'blue' })
    return <UiSaveButtons others={btns} dropdowns={ddOptions_dataItem()} />
  }

  const wrapper_confirmation = () => {

    let top;
    let content;
    let other;
    let noCommit;

    switch (currentConfirmationType) {
      case _appDataOptionTypes.createClientProfiles:
        content = <TreeViewer data={clientProfiles} subNames={true} />
        break;

      case _appDataOptionTypes.mergeToCollection:
        if (selectedAppData) {
          content = <TreeViewer data={selectedAppData} subNames={true} />
          top = dropdown()
        }
        break;

      case _appDataOptionTypes.restoreFromBackupData:
        if (backupData) {
          content = <TreeViewer data={backupData} subNames={true} />
        }
        break;

      case _appDataOptionTypes.mergeDuplicates:
        if (duplicates) {
          content = <TreeViewer data={duplicates} subNames={true} removeOnNonFirst={true} />
        }
        break;

      case _appDataOptionTypes.fixDataLinks:
        if (currentDataLinks) {
          content = <TreeViewer data={currentDataLinks} subNames={true} scNames={true} />
        }
        break;
      case _appDataOptionTypes.createAppLinks:
        if (appLinkData) {
          content = <TreeViewer data={appLinkData} subNames={true} scNames={true} />
        }
        break;
      // case _appDataOptionTypes.createDocuments:
      //   if (selectedCollectionData) {
      //     content = <TreeViewer data={selectedCollectionData} subNames={true} />
      //   }
      //   break;
      case _appDataOptionTypes.exportAllToGoogleSheets:
        if (selectedAppData) {
          content = <TreeViewer data={_appDataDocuments} subNames={true} scNames={true} />
          other = ' (' + googleSheetsId + ')'
        }
        break;
      case _appDataOptionTypes.exportToGoogleSheets:
        if (selectedAppData) {
          content = <TreeViewer data={selectedAppData} subNames={true} scNames={true} />
          other = ' (' + googleSheetsId + ')'
        }
        break;

      case _appDataOptionTypes.viewDocumentData:
        if (appDataDocuments) {
          content = <TreeViewer data={appDataDocuments} subNames={true} scNames={true} />
        }
        noCommit = true
        break;

      default:
    }

    return <ConfirmationWrapper
      top={top}
      showConfirmation={currentConfirmationType}
      other={other}
      handleCommit={!noCommit && handleCommit}
      handleShow={handle_showConfirmation}
      updating={updating || _updating}
      content={content}
      allowCommit={true}
    />
  }

  /**
* 
* @returns menu items of all the static views keys
*/
  const wrapper_content = () => currentConfirmationType ? wrapper_confirmation() : <Wrapper
    header={header_main()}
    search={searchInput()}
    content={itemSquares_allData()}
    footer={footer_content()}
    wrapperType={fromLongPress ? wrapperTypes.padded : wrapperTypes.paddedHeaderAndFooter}
    updating={updating || _updating}
  />

  /**
   * 
   * @returns content of the selected static view
   */
  const wrapper_appDataItem = () => currentConfirmationType ? wrapper_confirmation() : <Wrapper
    header={header_top()}
    content={itemSquares_pageData()}
    footer={footer_appDataItem()}
    wrapperType={wrapperTypes.padded}
    css={{ container: 'app-dark-mode' }}
    updating={updating || _updating}
  />

  const wrapper_appDataItem_modify = () => <Wrapper
    header={header_top()}
    content={
      <ItemModifySidebar
        getTheData={true}
        collectionName={selectedInfo.appDataItemKey}
        itemData={selectedInfo.appDataItem}
        selectedEditItemKey={selectedInfo.appDataItemItem}
        singleDataItem={true}
        viewItem={selectedInfo.viewItem}
      />}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  return <MiniSwipe
    swipeItems={[
      wrapper_content(),
      selectedInfo.appData ? wrapper_appDataItem() : <div></div>,
      selectedInfo.appDataItem ? wrapper_appDataItem_modify() : <div></div>
    ]
    }
    currentIndex={currentIndex}
    origin="AppDataSidebar"
  />
}

export default AppDataSidebar
